import { useState } from 'react';

import { GridApi } from '@mint-lib/ag-grid/community';
import { Add, ChevronRight } from '@mint-lib/icons';
import {
  Popover,
  PopoverContent,
  PopoverPortal,
  PopoverTrigger,
} from '@mint-lib/tw-components';
import { MediaPlan } from '@mint-sdk/api-media-plan';

import AddRowInside from '../AddRowInside/AddRowInside.jsx';
import MenuItemBase from './MenuItemBase.jsx';

type AddRowMenuItemProps = {
  mediaData: MediaPlan.MediaData;
  name: string;
  api: GridApi<MediaPlan.MediaData>;
  closeMenu: () => void;
  disabled?: boolean;
};

export const AddRowMenuItem = ({
  mediaData,
  name,
  api,
  closeMenu,
  disabled = false,
}: AddRowMenuItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover open={isOpen && !disabled} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        {/** translate-0 fix popover positioning */}
        <div className="translate-0">
          <MenuItemBase
            name={name}
            startAdornment={<Add />}
            endAdornment={<ChevronRight />}
            onHover={() => setIsOpen(true)}
            disabled={disabled}
          />
        </div>
      </PopoverTrigger>
      <PopoverPortal>
        <PopoverContent
          className="z-popover w-74 px-0 py-1"
          align="start"
          side="right"
        >
          {/** ag-custom-component-popup prevent AG Grid to close menu on click inside AddRowInside */}
          <div className="ag-custom-component-popup">
            <AddRowInside
              mediaData={mediaData}
              closeMenu={() => {
                setIsOpen(false);
                closeMenu();
              }}
              api={api}
            />
          </div>
        </PopoverContent>
      </PopoverPortal>
    </Popover>
  );
};
